import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import { StoreDetailsService } from '../../../../services/store-details.service';

declare var SUBMIT_LEAD_TOKEN: any;

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnInit {
  @Input() car: any;


  btnShow = true;
  mailsent = false;
  spinner = false;
  enquireFormHide = true;
  showroomCheck: string;
  contactNumber: string;
  leadToken: string;


  public dataCrm = {};
  public formDetails = {};
  public enquireForm = new FormGroup({
    name: new FormControl('',
      [Validators.required, Validators.minLength(3)]),
    surname: new FormControl('', [Validators.required, Validators.minLength(3)]),
    contactNumber: new FormControl('', [Validators.required, Validators.min(99999999), Validators.max(999999999)]),
    eMail: new FormControl('', [Validators.required, Validators.email])
  });

  constructor(
    private http: HttpClient,
    public storeDetails: StoreDetailsService,
  ) { }

  ngOnInit() {
  }


  onSubmit() {
    this.spinner = true;
    this.btnShow = false;
    this.formDetails = {
      notification: {
        ToList: 'webmaster@vmgsoftware.co.za',
        CcList: '',
        BccList: '',
        Subject: 'VMG Test Site Website enquiry for ' + this.car.make + ' ' + this.car.series,
        Message: ''
          + '\n\nMake: ' + this.car.make
          + '\nModel: ' + this.car.series
          + '\nstockId: ' + this.car.stock_id
          + '\nPrice: ' + this.car.selling_price
          + '\nContact: ' + this.enquireForm.value.contactNumber,
        MessageSubject: 'Website enquiry',
        ToName: '',
        // ToName: this.storeDetails.store.eMail.enquireCarMailName,
        FromName: this.enquireForm.value.name + ' ' + this.enquireForm.value.surname,
        FromEmail: this.enquireForm.value.eMail,
        Attachments: {}
      }
    };

    this.dataCrm = {
      'branch_guid': 'bfadd7a1-37ed-4959-a6f3-19677412877f',
      'cellphone_no': this.enquireForm.value.contactNumber.toString(),
      'make': this.car.make,
      'colour': this.car.colour,
      'email_address': this.enquireForm.value.eMail,
      'lead_name': this.enquireForm.value.name + ' ' + this.enquireForm.value.surname,
      'lead_source': 'Website',
      'mileage': this.car.mileage,
      'price': this.car.selling_price,
      'selling': false,
      'stock_id': this.car.stock_id,
      'year': this.car.year,
      'dealer_id': this.car.company_id
    };

    const dataString = JSON.stringify(this.formDetails);
    const leadString = JSON.stringify(this.dataCrm);

    this.http.post<any>(this.storeDetails.store.serverMailSellApi, dataString,
      { headers: this.storeDetails.store.headers, reportProgress: true }).subscribe(
      (res) => {
        this.enquireForm.reset();
        this.enquireFormHide = false;
        this.btnShow = true;
        this.mailsent = true;
        this.spinner = false;
      },
      (err) => {
        this.btnShow = false;
        this.spinner = false;
      }
    );
    this.http.get<any>('https://api.vmgdms.com/vmg/auth/token',
      { headers: {
          'content-type': 'application/json',
          accept: 'application/json',
        }}).subscribe(
      (res) => {

        this.leadToken = res.id_token;
        this.http.post<any>('https://api.vmgdms.com/leads/v1/new_dealer_lead', leadString,
          { headers: {
              'content-type': 'application/json',
              accept: 'application/json',
              authorization: 'Bearer ' + this.leadToken
            }}).subscribe(
          () => {
          },
          (err) => {
            console.log('leads failed: ', err);
          }
        );
      },
      (err) => {
        console.log('Failed getting auth token: ', err);
      }
    );
  }
}
